export interface Testimonio {
  id: string
  nombre: string
  detalle: string
  imagen: string
}

export const testimonios: Testimonio[] = [
  {
    id: 't-1',
    nombre: 'Lucas',
    detalle: 'Sedán 2015 · compró con financiación',
    imagen:
      'https://cdn.magicpatterns.com/uploads/7TRTd5tSRfHAy7TvEZhECj/heylloyd-image-1787677268008.png',
  },
  {
    id: 't-2',
    nombre: 'Emi R. Castillo',
    detalle: 'Toyota Hilux · entrega en el interior',
    imagen:
      'https://cdn.magicpatterns.com/uploads/soWo1Y99nen27Qcxvknk8f/heylloyd-image-1787676948925.png',
  },
  {
    id: 't-3',
    nombre: 'Pedrito G. Catan',
    detalle: 'Volkswagen Bora · usado seleccionado',
    imagen:
      'https://cdn.magicpatterns.com/uploads/ctmBa7a3Mp2Jq2regFUqSg/heylloyd-image-1787676857241.png',
  },
  {
    id: 't-4',
    nombre: 'Gustavo Zona Sur',
    detalle: 'Operación cerrada con permuta',
    imagen:
      'https://cdn.magicpatterns.com/uploads/5VtctFYDrVyHCKLqi7NDfo/heylloyd-image-1787676701618.png',
  },
]
